export const ru = {
    companion_add: 'Добавить попутчика',
    empty_title: 'В командировку вместе с близкими',
    empty_description: 'Соберём все услуги и бронирования в одном месте для удобного планирования поездок для вас и ваших близких',
};
